import { ReactComponent as OneStepLogo } from '../../assets/icons/Login/logo.svg';

export const LoginHeader = () => (
  <div className="flex items-center gap-2">
    <OneStepLogo />
    <div className="text-neutral-p3 font-bold	text-2.5xl">OneStep</div>
  </div>
);
